<template>
    <v-container fluid>
        <v-card flat>
            <v-card-title>Frequently Asked Questions
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="addFaq()"><v-icon small class="mx-2">mdi-plus</v-icon>Add New Faq</v-btn>
            </v-card-title>
        </v-card>
        <v-card elevation="0" class="px-3">
            <v-card-title>
                <template>
                    <v-row>
                        <v-col cols="8">
                            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search Faqs" single-line
                                hide-details></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-select v-model="selectedCategory" :items="categoryOptions" label="Filter by Category"
                                prepend-icon="mdi-filter" @change="handleCategoryChange">
                            </v-select>
                        </v-col>
                    </v-row>
                </template>
            </v-card-title>
            <v-data-table :loading="loading" :headers="headers" :items="getFaqs" :search="search" item-key="id"
                single-expand sort-by="updated_at" sort-desc @click:row="getFaq">
                <template v-slot:item.question="{ item }">
                    <span>
                        {{ item.question | trimLength }}
                    </span>
                </template>
                <template v-slot:item.answer="{ item }">
                    <span>
                        {{ item.answer | trimLength }}
                    </span>
                </template>
                <template v-slot:item.category="{ item }">
                    {{ item.category }}
                </template>
                <template v-slot:item.updated_at="{ item }">
                    {{ item.updated_at | formatDate }}
                </template>
                <template v-slot:item.actions="{ }">
                    <v-icon>mdi-pencil</v-icon>
                </template>
            </v-data-table>
        </v-card>
    </v-container>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
export default {
    name: 'faqManagement',
    data() {
        return {
            loading: false,
            search: "",
            height: window.innerHeight,
            headers: [
                { text: 'Question', value: 'question', align: 'start' },
                { text: 'Answer', value: 'answer' },
                { text: 'Category', value: 'category', sort: 'asc' },
                { text: 'Updated At', value: 'updated_at', align: 'start' },
                { text: 'Actions', value: 'actions' }
            ],
            selectedCategory: ''
        }
    },
    computed: {
        ...mapGetters(['getFaqs', 'getFaqCategory']),
        categoryOptions() {
            console.log('this.getFaqCategory.map((category) => { return category.categoryName })', this.getFaqCategory.map((category) => { return category.categoryName }))
            return this.getFaqCategory.map((category) => { return category.categoryName })
        },
    },
    methods: {

        handleCategoryChange() {
            console.log('Hello there')
        },
        getFaq(item) {
            console.log('Clicked FAQ: ', item)
            item["isNew"] = false
            this.$store.commit('setSelectedFaq', item)
            this.$store.commit('setViewFaq', true)
        },
        addFaq() {
            // let tempFaqs = this.getFaqs.sort((a, b) => { return a.linkID - b.linkID })
            // console.log('Temp faqs: ', tempFaqs[tempFaqs.length - 1])
            // this.$store.commit('setSelectedFaq', { linkID: tempFaqs[tempFaqs.length - 1].linkID + 1, isNew: true, qrDetails: {"qrlist":[{"name":"Button Name","link":"Link to website"}]} })
            this.$store.commit('setAddFaq', true)
        }
    },
    mounted() {
        this.$store.dispatch("pullFaqCategories")
        this.$store.dispatch("pullFaqs")
        this.$store.dispatch("pullMaps")
    },
    filters: {
        formatDate(val) {
            if (!val) { return '-' }
            return moment(val).format('L')
        },
        formatDuration(val) {
            if (!val) { return '-' }
            return moment(val).format('mm:ss')
        },
        formatTime(val) {
            if (!val) { return '-' }
            return moment(val).format('LT')
        },
        formatStringTime(val) {
            if (!val) { return '-' }
            return moment(val).format('LTS')
        },
        formatDateFromNow(val) {
            if (!val) { return '-' }
            return moment(val).fromNow();
        },
        trimLength(val) {
            if (typeof val !== 'string') return val
            if (val === null) return val
            if (val === '') return val
            if (val.length <= 100) { return val }
            return `${val.substring(0, 65)}...`
        }
    },

}
</script>